export default __webpack_public_path__ + "static/media/python1.185f55d5.png";